import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';
import 'moment/locale/es';
import 'moment/locale/sv';

momentDurationFormatSetup(moment);
moment.locale('es');
// moment.locale(navigator.language || navigator.userLanguage);
